import type { MutationTree } from 'vuex'
import type { DeviceModelsState } from './types'
import { DEVICE_MODELS_MUTATIONS } from './types'
import type { UnpackedModelMetadata } from '@/services/device-service/devices'

interface IDeviceModelsMutations extends MutationTree<DeviceModelsState> {
  [DEVICE_MODELS_MUTATIONS.SET_MODELS_META_DATA](
    state: DeviceModelsState,
    data: UnpackedModelMetadata
  ): void
}

const mutations: IDeviceModelsMutations = {
  [DEVICE_MODELS_MUTATIONS.SET_MODELS_META_DATA](state, data) {
    state.modelsMetaData = data
  }
}

export default mutations
